import {Component} from 'panel';

import {setOptState} from '../opt.js';
import {deactivateTracking} from '../tracking.js';

import template from './index.jade';
import './index.styl';

class GdprBanner extends Component {
  get config() {
    return {
      template,
      defaultState: {hidden: true},
      helpers: {
        onAccept: () => {
          setOptState(`in`, `tracking`);
          setOptState(`in`, `storage`);
          this.dismiss();
        },
        onDismiss: () => {
          setOptState(`out`, `tracking`);
          setOptState(`out`, `storage`);
          this.dismiss();
        },
      },
      hooks: {
        postUpdate: () => {
          this.updateHelpWidget();
        },
      },
    };
  }

  show() {
    // deactivate tracking by default while banner is present; will be re-activated on opt-in
    deactivateTracking();
    this.update({hidden: false});
  }

  dismiss() {
    this.update({hidden: true});

    window.setTimeout(() => {
      this.parentNode.removeChild(this);
    }, 400); // remove after fadeout animation
  }

  updateHelpWidget() {
    if (!this._helpWidget) {
      this._helpWidget = document.getElementsByTagName(`mp-help-widget`)[0];
      this.originalHelpWidgetClass = this._helpWidget ? this._helpWidget.className : ``;
    }

    if (this._helpWidget) {
      this._helpWidget.className = this.originalHelpWidgetClass + (
        this.state.hidden ? `` : ` gdpr-banner-present`
      );
    }
  }
}

customElements.define(`mp-gdpr-banner`, GdprBanner);
